import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ragCostAnalysisTable } from "../../service/ragApiServices";
import { useAzureData } from "../../context/AzureContext";
// import "./RagCostAnalysisPage.css"

// @ts-ignore
const RagCostTable = ({ ragFilters }) => {
    const { apiToken } = useAzureData();
    const location = useLocation();
    const navigate = useNavigate();
    const [tableData, setTableData] = useState<any>([]);
    const [collapsedState, setCollapsedState] = useState<any>({});
    const [loading, setLoading] = useState<any>(true);
    const [message, setMessage] = useState<any>('');
    const loggedInUser = ragFilters ? ragFilters?.created_by : ""
    const hasFetchedRef = useRef(false);
    // Retrieve state passed from the previous page
    const {
        servicenames: selectedServiceNames,
        vector_search_index_names: selectedVectorSearchNames,
        start_date: startDate,
        end_date: endDate,
        environment: selectedEnvironment,
    } = ragFilters || {};

    function toLocalISO(date: any) {
        if (!date) return null;
      
        const d = new Date(date); // handles string or Date
      
        if (isNaN(d.getTime())) {
          throw new Error("Invalid date passed to toLocalISO");
        }
      
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
      
        return `${year}-${month}-${day}`;
    }


    const fetchTableData = async () => {
        try {
            const input = {
                created_by: loggedInUser,
                servicenames: selectedServiceNames,
                vector_search_index_names: selectedVectorSearchNames,
                start_date: new Date(toLocalISO(startDate)).toISOString(),
                end_date: new Date(toLocalISO(endDate)).toISOString(),
                environment: selectedEnvironment,
            };
            const response:any = await ragCostAnalysisTable(apiToken, input)
            if (!response.data.data || response.data.data.length === 0) {
                setMessage("No Data Found")
                setLoading(false)
                return;
            }
            const updatedData = response.data.data.map((row:any) => {
                let totalCost = 0;
                const costSet:any = {}
                row.costDetails.forEach((c:any) => {
                    if (!costSet[c.rag_app_name]) {
                        costSet[c.rag_app_name] = {}
                        costSet[c.rag_app_name][c.cost_type] = c.cost
                    } else if (!costSet[c.rag_app_name][c.cost_type]) {
                        costSet[c.rag_app_name][c.cost_type] = c.cost
                    } else {
                        costSet[c.rag_app_name][c.cost_type] += c.cost
                    }
                    totalCost += c.cost
                })
                row.isCollapsed = true;
                row.totalCost = totalCost
                row.costSet = costSet
                return row
            })
            setTableData(updatedData);
        } catch (error) {
            console.error("Error fetching table data:", error);
            setMessage("Error fetching table data")
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {

        if (
            selectedServiceNames &&
            selectedVectorSearchNames &&
            startDate &&
            endDate &&
            selectedEnvironment
        ) {
            if (hasFetchedRef.current) return; // prevent double call
            hasFetchedRef.current = true;
            fetchTableData();
        }
        return () => {
            setMessage("")
            setLoading(true)
            setTableData([])
        }
    }, [
        selectedServiceNames,
        selectedVectorSearchNames,
        startDate,
        endDate,
        loggedInUser,
        selectedEnvironment,
    ]);

    const toggleRow = (servicename:any) => {
        setCollapsedState((prev:any) => ({
            ...prev,
            [servicename]: !prev[servicename],
        }));
    };

    const getCost = (costValues:any) => {
        const currencyType = "$";
        let cummulativeCost = 0;
        for (const cost of costValues) {
            if (cost) {
                cummulativeCost += cost
            }
        }
        return `${currencyType}${cummulativeCost.toFixed(2)}`
    };


    return (
        <div className="unilever-content">
            {/* <h4 className="text-center mb-4 page-title">Table View Analysis</h4> */}
            <div className="d-flex justify-content-end mb-3">
                {/* <button
                    onClick={() => navigate("/rag-cost-analysis")}
                    className="unilever-btn-border"
                >
                    Go Back
                </button> */}
            </div>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>Service Name</th>
                        <th>Rag Apps</th>
                        <th>Usage Date</th>
                        <th>Total Cost</th>
                    </tr>
                </thead>
                {loading && "Loading..."}
                {message && !tableData.length && "No Data Found"}
                <tbody>
                    {/* @ts-ignore */}
                    {tableData?.map(({ servicename, totalCost, ragApps, costSet, usage_date }, index) => (
                        <React.Fragment key={index}>
                            <tr key={servicename}>
                                <td>
                                    <button
                                        onClick={() => toggleRow(servicename)}
                                        className="btn btn-link"
                                        style={{ textDecoration: "none" }}
                                    >
                                        {collapsedState[servicename] ? "-" : "+"}
                                    </button>{" "}
                                    {servicename}
                                </td>
                                <td colSpan={"1"}>{""}</td>
                                <td>{(usage_date).split("T")[0] || ""}</td>
                                <td>${totalCost.toFixed(2)}</td>
                            </tr>
                            <tr>
                                {collapsedState[servicename] &&
                                    <React.Fragment>
                                        <td></td>
                                        <td>
                                            <table width={"100%"} style={{ borderCollapse: "collapse", marginBottom: "0px" }}>
                                                <thead>
                                                    <tr>
                                                        <td colSpan={"0.2"} style={{ border: "grey solid 0.1px" }}>Rag App</td>
                                                        <td colSpan={"0.2"} style={{ border: "grey solid 0.1px" }}>Compute</td>
                                                        <td colSpan={"0.2"} style={{ border: "grey solid 0.1px" }}>Model</td>
                                                        <td colSpan={"0.2"} style={{ border: "grey solid 0.1px" }}>Vector DataBase</td>
                                                        <td colSpan={"0.2"} style={{ border: "grey solid 0.1px" }}>Parsing</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Object.keys(ragApps).map((app) => {
                                                        const {
                                                            serving_cost = null,
                                                            azure_storage_cost = null,
                                                            azure_document_intelligence_cost = null,
                                                            openai_gpt_4o_cost = null,
                                                            azure_query_runtime_cost = null,
                                                            embedding_cost = null,
                                                            ingestion_cost = null,
                                                            azure_ai_translator_cost = null,
                                                            azure_cognitive_services_speech_cost = null
                                                        } = costSet[app];
                                                        return (
                                                            <tr>
                                                                <td colSpan={"0.2"} style={{ border: "grey solid 0.5px" }}>{app}</td>
                                                                <td colSpan={"0.2"} style={{ border: "grey solid 0.5px" }}>{getCost([serving_cost, azure_query_runtime_cost])}</td>
                                                                <td colSpan={"0.2"} style={{ border: "grey solid 0.5px" }}>{getCost([embedding_cost, openai_gpt_4o_cost])}</td>
                                                                <td colSpan={"0.2"} style={{ border: "grey solid 0.5px" }}>{getCost([azure_storage_cost, ingestion_cost])}</td>
                                                                <td colSpan={"0.2"} style={{ border: "grey solid 0.5px" }}>{getCost([azure_document_intelligence_cost, azure_ai_translator_cost, azure_cognitive_services_speech_cost])}</td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </React.Fragment>
                                }
                            </tr>

                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default RagCostTable;
